export default "__VITE_ASSET__xM4ykIhk__"